// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonMap_button__GdaSi"};